import UIComponent from "../../common/UIComponent";
import "./index.css";
export default class FullscreenBtn extends UIComponent {

  constructor(elementId, interfaces) {
    super();
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.interfaces.on(VhallPlayer.FULLSCREEN_CHANGE,res => {
      res === "fullscreen" ? this.fullScreenBtn.classList.add("full") : this.fullScreenBtn.classList.remove("full");
    });
    this.init();
  }

  init() {
    this.fullScreenBtn = document.createElement("span");
    this.fullScreenBtn.setAttribute("class", "vhallPlayer-fullScreen-btn");
    this.fullScreenBtn.onclick = this.handleBtnClick.bind(this)
    this.insertElement(this.elementId, this.fullScreenBtn);
  }

  handleBtnClick() {
    if(this.interfaces.isFullscreen()){
      this.fullScreenBtn.classList.remove("full");
      this.interfaces.exitFullScreen();
    }else{
      this.fullScreenBtn.classList.add("full");
      this.interfaces.enterFullScreen();
    }
  }


}